import React from "react";
import { Container, Row, Col } from "reactstrap";
import "../profile.css";


class Profile extends React.Component {

  //List everything we need right at the start.
  //Makes the whole thing a little easier to follow.
  constructor() {
    super();
    this.state = {
      email: global.userData.email,
      name: global.userData.name,
      picture: global.userData.picture,

      domain: 'https://app.bevl.ltd',
      fmAuth: 'Basic RGF0YUFQSUZ1bGxBY2Nlc3M6Q1RuTDJ1eVdie0JEYk1nMjI7OEdUYjNlWUx4QzNY',
      fmFileName: 'Client%20Portal',
      layoutOne: 'Customers',
      layoutTwo: 'Invoices',

      invoices: [],
      company: [],
      contactID: null,
      token: null,
      value: true,
    }
  };

  //Start the data grabbing process!
  async componentDidMount(){


    //First off, log a session with FileMaker Server and grab a token.
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': this.state.fmAuth,
        },
        body: ''
    };
    const url = this.state.domain + "/fmi/data/v1/databases/" + this.state.fmFileName + "/sessions";
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    this.setState({ token: data.response.token });


    //Now we have a token, we use the email address to perform a find in the CUSTOMERS table.
    //This let's us grab the UUID of the CUSTOMER.
    const requestOptionsFindEmail = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.state.token,
      },
      body: '{ "query": [{"d__EmailAddresses": "\\"' + this.state.email + '\\""}]}'
    }
    const urlFindEmail = this.state.domain + "/fmi/data/v1/databases/" + this.state.fmFileName + "/layouts/" + this.state.layoutOne + "/_find";
    await fetch(urlFindEmail, requestOptionsFindEmail)
    .then(responseFindEmail => responseFindEmail.json())
    .then(data => this.setState({ 'company': data.response.data })) ;

    //Finally, we delete the open user session within FileMaker Server (prevents further use of this token)
    const requestOptionsDel = {
      method: 'DELETE',
    };
    const urlDel = this.state.domain + "/fmi/data/v1/databases/" + this.state.fmFileName + "/sessions/" + this.state.token ;
    const responseDel = await fetch(urlDel, requestOptionsDel);
    await responseDel.json();

  }; //Close the componentDidMount function





  render() {
    return (
      <div>
      {this.state.company.map(function(data) {
        return (

      <div className="page-section">
      <div className="title-section">
      <table className="profile-table">
      <tr>
      <td>
      <img className="profile-img" src={`data:image/jpeg;base64,${data.fieldData.c__LogoBase64}`} />
      </td>
      <td>
      <h2>
      Profile
      </h2>
      <div className="sub-title-section">
      {data.fieldData.d__CompanyName}
      </div>
      </td>
      </tr>
      </table>
      <p>
      <div className="table-header">ADDRESS</div>
      <div className="record-data">{data.fieldData.c__AddressFull}</div>
      </p>
      <p>
      <div className="table-header">PHONE</div>
      <div className="record-data">{data.fieldData.d__Phone}</div>
      </p>
      <p>
      <div className="table-header">CONTACT EMAIL</div>
      <div className="record-data">{data.fieldData.d__Email}</div>
      </p>

      </div>
      </div>

    )
  }
)
}
</div>
);
};





}

export default Profile;
